"use client";

import { useEffect, useState } from "react";

export interface Role {
	id: string;
	name: string;
	description: string | null;
	weight: number;
	color: string;
	icon: string;
	createdAt: string;
}

interface UseRolesReturn {
	roles: Role[];
	isLoading: boolean;
	error: string | null;
}

export function useRoles(): UseRolesReturn {
	const [roles, setRoles] = useState<Role[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchRoles = async () => {
			try {
				const response = await fetch("/api/roles");
				if (response.ok) {
					const data = await response.json();
					setRoles(data.roles || []);
				} else {
					setError("Failed to fetch roles");
				}
			} catch (err) {
				setError("Error fetching roles");
				console.error("Error fetching roles:", err);
			} finally {
				setIsLoading(false);
			}
		};

		fetchRoles();
	}, []);

	return { roles, isLoading, error };
}
